import HomePage from 'pages/home/index.p'

export default HomePage
